function validateEmpty(data: string, name: string | null): string | null {
    if (data.length === 0) {
        return `${name != null ? name : '입력값'}를 확인 해주세요.`;
    } else {
        return null;
    }
}

export { validateEmpty };